module.exports = __webpack_public_path__ + "img/sfb.8c1e1e25.png";